import { createRouter, createWebHistory } from 'vue-router'
import {normalRoutes} from '@/configs/route.config'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: normalRoutes
})

export default router
